<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.dataBox.basics.title'
      :titleIcon='$store.state.icons.dataBox.basics.icon'
      :titleIconColor='$store.state.icons.dataBox.basics.iconColor'
      :showEdit='!expense.reconciliation && !expense.is_posted'
      @edit='edit'
    >
      <wc-two-column-table
        :items='basicsData'
      ></wc-two-column-table>
    </wc-data-box>


    <wc-dialog
      :title='$store.state.icons.dataBox.basics.title'
      :icon='$store.state.icons.dataBox.basics.icon'
      :iconColor='$store.state.icons.dataBox.basics.iconColor'
      :showDialog='showDialog'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid'>
        <v-row dense>
          <v-col cols='12' md='6'>
            <wc-datepicker
              label='Purchase date'
              v-model='expenseCopy.expense_date'
              :min='$store.state.misc.settings.earliest_post_date'
              required
            ></wc-datepicker>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              v-model='expenseCopy.purchased_at'
              label='Store/Location'
              :rules='[rules.required]'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6'>
            <v-autocomplete
              label='Paid from'
              :items='payment_accounts'
              item-value='id'
              item-text='name'
              v-model='expenseCopy.payment_account'
            ></v-autocomplete>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              v-model='expenseCopy.reference_number'
              label='Reference number'
            ></v-text-field>.
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              v-model='expenseCopy.po_number'
              label='PO number'
            ></v-text-field>.
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              v-model='expenseCopy.invoice_number'
              label='Invoice number'
            ></v-text-field>.
          </v-col>
          <v-col cols='12' md='6'>
            <v-autocomplete
              label='Purchased by'
              :items='staff'
              item-text='name_display'
              item-value='id'
              v-model='expenseCopy.purchased_by'
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'expense-basics',
  mixins: [formRules],
  data: () => ({
    expenseCopy: {},
    isFormValid: false,
    showDialog: false
  }),
  props: {
    expense: {
      required: true
    },
    payment_accounts: {
      required: true
    },
    staff: {
      required: true
    }
  },
  computed: {
    basicsData () {
      if (this.expense) {
        return [
          { text: 'Expense date', value: this.$options.filters.shortDate(this.expense.expense_date) },
          { text: 'Store/Location', value: this.expense.purchased_at },
          { text: 'Paid From', value: this.expense.payment_account ? this.expense.payment_account_obj.name : 'Not set?' },
          { text: 'Ref Number', value: this.expense.reference_number },
          { text: 'Purchased by', value: this.expense.purchased_by ? this.expense.purchased_by_obj.name_display : '' },
          { text: 'PO Number', value: this.expense.po_number },
          { text: "Invoice Number", 
            value: this.expense.duplicate_invoice ? `DUPLICATE: ${this.expense.invoice_number}` : this.expense.invoice_number,
            error: this.expense.duplicate_invoice
          }
        ]
      }
      return []
    },
    paymentMethods () {
      return this.$store.state.misc.globalOptions.paymentTypes
    }
  },
  methods: {
    resetCopy () {
      this.expenseCopy = _.cloneDeep(this.expense)
    },
    edit () {
      this.resetCopy()
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.expenseCopy)
      this.showDialog = false
    }
  }
}
</script>
